<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D63fXR/tc-custom/9781466899636.jpg?1722313789775" alt="This image is the cover for the book Patriotic Gore"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Patriotic Gore
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Featuring critical and biographical portraits of notable figures of the American Civil War, <i>Patriotic Gore</i> remains one of Edmund Wilson's greatest achievements. Considered one of the 100 Best Nonfiction books by The Modern Library.</b><br/><br/>Figures discussed include Harriet Beecher Stowe, Abraham Lincoln, Ulysses S. Grant, William Tecumseh Sherman, and Oliver Wendell Holmes, among many others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edmund Wilson
      </h2>
      
      <p class="authorDescription body article"><B>Edmund Wilson</B> (1895-1972) was a novelist, memoirist, playwright, journalist, poet, and editor but it is as a literary critic that he is most highly regarded. His more than twenty books include <I>Axel’s Castle</I>, <I>Patriotic Gor</I>e, <I>To the Finland Station</I>, and <I>Memoirs of Hecate County.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus & Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18524735